export default __webpack_public_path__ + "static/media/banner3.a2bb23ce.jpg";